import type { QuoteNarrativeLayoutVariant } from "@/@sdk/holiday-quotes-x/holiday-quotes-x-model";

export const QUOTE_NARRATIVE_LAYOUT_OPTIONS: {
  value: Exclude<QuoteNarrativeLayoutVariant, "hotel_cards">;
  label: string;
  description: string;
}[] = [
  {
    value: "horizontal_tabs",
    label: "Horizontal tabs",
    description: "Day pills across the top (default)",
  },
  {
    value: "vertical_tabs",
    label: "Vertical tabs",
    description: "Day list on the left, content on the right",
  },
  {
    value: "accordion",
    label: "Accordion",
    description: "One day open at a time",
  },
  {
    value: "collapsible",
    label: "Collapsible",
    description: "Multiple days can stay open",
  },
];

export const QUOTE_ACCOMMODATIONS_LAYOUT_OPTIONS: {
  value: QuoteNarrativeLayoutVariant;
  label: string;
  description: string;
}[] = [
  {
    value: "hotel_cards",
    label: "Hotel cards",
    description: "Card grid with View opening full details",
  },
  {
    value: "horizontal_tabs",
    label: "Horizontal tabs",
    description: "Stay pills across the top",
  },
  {
    value: "vertical_tabs",
    label: "Vertical tabs",
    description: "Stay list on the left, content on the right",
  },
  {
    value: "accordion",
    label: "Accordion",
    description: "One stay open at a time (collapsed by default)",
  },
  {
    value: "collapsible",
    label: "Collapsible",
    description: "Multiple stays can stay open",
  },
];

/** Brochure Mode flights: only two presentation modes. */
export type TripFlightsLayoutVariant = "hotel_cards" | "collapsible";

export const QUOTE_FLIGHTS_LAYOUT_OPTIONS: {
  value: TripFlightsLayoutVariant;
  label: string;
  description: string;
}[] = [
  {
    value: "hotel_cards",
    label: "Flight cards",
    description: "Full flight details in a card grid",
  },
  {
    value: "collapsible",
    label: "Flight list",
    description: "Full flight blocks stacked vertically",
  },
];

export function resolveNarrativeLayout(
  layout?: QuoteNarrativeLayoutVariant | null
): QuoteNarrativeLayoutVariant {
  return layout || "horizontal_tabs";
}

export function resolveAccommodationsLayout(
  layout?: QuoteNarrativeLayoutVariant | null
): QuoteNarrativeLayoutVariant {
  return layout || "hotel_cards";
}

export function resolveFlightsLayout(
  layout?: QuoteNarrativeLayoutVariant | null
): TripFlightsLayoutVariant {
  // `hotel_cards` = Flight cards; everything else (incl. legacy tabs/accordion) → list.
  if (layout === "hotel_cards") return "hotel_cards";
  if (layout == null) return "hotel_cards";
  return "collapsible";
}
